import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';

const paramKey: string = 'param';
let t_id: string;
let servicename: string;
let url: string;
let paramsdata: string;
@createModule('Iframe')
/**
 * Iframe module implementation.
 *
 * @author Lars-Olof Kreim <lars-olof.kreim@namics.com>
 */
export class Iframe extends TerrificSpec {
	$ctx: JQuery;
	url: string;
	framename: string;
	$frame: JQuery;
	usercentricsservicename: string;

	start(resolve: () => void) {
		this.$ctx = $(this._ctx);
		this.url = this.$ctx.data('url');
		t_id = this.$ctx.data('tId');
		servicename = this.$ctx.data('usercentricsServicename');
		url = this.$ctx.data('url');
		paramsdata = this.$ctx.data('params');
		this.$ctx.attr("id", "m-iframe-" + t_id);
		this.usercentricsservicename = this.$ctx.data('usercentricsServicename');

		if (this.url) {
			if (this.usercentricsservicename) {
				$(window).on('message', this.onPostmessage.bind(this));

				(window as any).addEventListener("UC_UI_INITIALIZED", function (e: CustomEvent) {
					const services = (window as any).UC_UI.getServicesBaseInfo() as any[];
					var sc = services.find(s => s.name === servicename);

					if (sc && sc.consent && sc.consent.status) {
						$(".uc-embedding-wrapper").hide();
					}
				});

				/**
				 * Handle Usercentrics consent changes. Check for Sitecore Analytics consent.
				 */
				(window as any).addEventListener("ucEvent", function (e: CustomEvent) {
					if (e.detail && e.detail.event == "consent_status") {
						if (e.detail[servicename] === true) {
							$(".uc-embedding-wrapper").hide();
							addUsercentricsIframe();
						}
					}
				});
			}
			else {
				$(window).on('message', this.onPostmessage.bind(this));
				this.addIframe();
			}
		}
		resolve();
	}

	addIframe() {
		this.framename = `toolframe_${this.$ctx.data('t-id')}`;
		this.$frame = $(`<iframe class="m-iframe__frame" name="${this.framename}" id="${this.framename}"></iframe>`);
		this.$ctx.append(this.$frame);
		if (!this.initPostCall()) {
			this.$frame.attr('src', this.url);
		}
		(this.$frame as any).iFrameResize();
	}

	initPostCall(): boolean {
		let params: any = this.$ctx.data('params') || ',';
		params = JSON.parse(`[${params.substr(0, params.length - 1)}]`);
		if (params.length > 0) {
			const $form = $('<form method="post" class="h-visuallyhidden">');
			$form.attr({
				action: this.url,
				target: this.framename,
			});
			$.each(params, (i, el) => {
				const name: string = Object.getOwnPropertyNames(el)[0];
				$form.append(`<input type="hidden" name="${name}" value="${el[name]}" />`);
			});
			$form
				.appendTo(this.$ctx)
				.submit()
				.remove();
			return true;
		}
		return false;
	}

	onPostmessage(e: any) {
		let data = e.originalEvent.data;
		if (typeof data === 'string') {
			data = data.split(',');
		}
		if (data[0] === 'setHeight') {
			if ((this.$frame[0] as any)['contentWindow'] === e.originalEvent.source) {
				this.$frame.css('height', `${parseInt(data[1], 10) + 20}px`);
			}
		}
	}
	stop() { }
}

function addUsercentricsIframe() {
	var framename = `toolframe_${t_id}`;
	var $frame = $(`<iframe class="m-iframe__frame" name="${framename}" id="${framename}"></iframe>`);
	$("#m-iframe-" + t_id).append($frame);
	if (!initUCPostCall()) {
		$(`#toolframe_${t_id}`).attr('src', url);
	}
	($(`#toolframe_${t_id}`) as any).iFrameResize();
}

function initUCPostCall() {
	let params: any = paramsdata || ',';
	params = JSON.parse(`[${params.substr(0, params.length - 1)}]`);
	if (params.length > 0) {
		const $form = $('<form method="post" class="h-visuallyhidden">');
		$form.attr({
			action: url,
			target: `toolframe_${t_id}`,
		});
		$.each(params, (i, el) => {
			const name: string = Object.getOwnPropertyNames(el)[0];
			$form.append(`<input type="hidden" name="${name}" value="${el[name]}" />`);
		});
		$form
			.appendTo($("#m-iframe-" + t_id))
			.submit()
			.remove();
		return true;
	}
	return false;
}